import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Users from './pages/Users';
import Projects from './pages/Projects';
import Dashboard from './pages/Dashboard';
import Notifications from './pages/Notifications';
import ProjectDetail from './pages/ProjectDetail';
import UserProfile from './pages/UserProfile';
import Settings from './pages/Settings';
import Logs from './pages/Logs';
import Storage from './pages/Storage';
import StatusPage from './pages/StatusPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Modal from './components/Modal';

const App: React.FC = () => {
  const [globalModal, setGlobalModal] = useState<any>({ isOpen: false, title: '', message: '', type: 'info' });

  useEffect(() => {
    const handleApiError = (event: any) => {
      setGlobalModal({
        isOpen: true,
        title: event.detail.title,
        message: event.detail.message,
        type: event.detail.type
      });
    };

    window.addEventListener('api-error', handleApiError);
    return () => window.removeEventListener('api-error', handleApiError);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Modal 
          {...globalModal} 
          onClose={() => setGlobalModal({ ...globalModal, isOpen: false })} 
          cancelText="Fechar"
        />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/status" element={<StatusPage />} />

          <Route element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="/user/:userId" element={<UserProfile />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/storage" element={<Storage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
